module.exports = __webpack_public_path__ + "static/media/router-24px.fa1b1cec.svg";